// «Ver abonos (N)»: el historial de abonos de una venta o compra (H57). Se muestra siempre
// que haya abonos, también con contabilidad automática: antes solo salía sin ella, y una
// compra pagada entera desde Cobros y Pagos (que sale de esa lista) dejaba el historial
// inalcanzable; «Ver transacción» muestra el movimiento, no el abono.
export function hasPaymentHistory(doc) {
    return !!(doc && Array.isArray(doc.payments) && doc.payments.length > 0);
}
